// @mui
import { useTheme } from '@mui/material/styles';
import { GlobalStyles } from '@mui/material';
import { useLocation } from 'react-router-dom';
import palette from '../../theme/palette';

// ----------------------------------------------------------------------

// O SnackbarProvider é único e global, montado acima do <Router /> — herda o tema
// ambiente (o do dashboard), mesmo dentro de rotas que se forçam claras via
// PublicPageTheme (que só envolve o conteúdo da página, não este provider). Um
// segundo SnackbarProvider aninhado não resolveria: GlobalStyles não tem escopo
// real de subárvore, e o `#root .SnackbarContent-root` do aninhado sobrescreveria
// o do dashboard inteiro. Forçar a paleta clara aqui, por rota, é o jeito seguro.
const FORCE_LIGHT_PATH_PREFIX = '/subscriptions';

export default function StyledNotistack() {
  const theme = useTheme();
  const { pathname } = useLocation();

  const forceLight = pathname.startsWith(FORCE_LIGHT_PATH_PREFIX);
  const activePalette = forceLight ? palette('light') : theme.palette;
  const isLight = forceLight ? true : theme.palette.mode === 'light';

  const inputGlobalStyles = (
    <GlobalStyles
      styles={{
        '#root': {
          '.SnackbarContent-root': {
            width: '100%',
            padding: theme.spacing(1),
            margin: theme.spacing(0.25, 0),
            boxShadow: theme.customShadows.z8,
            borderRadius: theme.shape.borderRadius,
            color: isLight ? activePalette.common.white : activePalette.grey[800],
            backgroundColor: isLight ? activePalette.grey[900] : activePalette.common.white,
            '&.SnackbarItem-variantSuccess, &.SnackbarItem-variantError, &.SnackbarItem-variantWarning, &.SnackbarItem-variantInfo':
              {
                color: activePalette.text.primary,
                backgroundColor: activePalette.background.paper,
              },
            [theme.breakpoints.up('md')]: {
              minWidth: 240,
            },
          },
          '.SnackbarItem-message': {
            padding: '0 !important',
            fontWeight: theme.typography.fontWeightMedium,
          },
          '.SnackbarItem-action': {
            marginRight: 0,
            color: activePalette.action.active,

            '& svg': {
              width: 20,
              height: 20,
            },
          },
        },
      }}
    />
  );

  return inputGlobalStyles;
}
